import React from 'react';
import { Grid } from '@material-ui/core';
import jalaliMoment from 'jalali-moment';
import * as Unicons from '@iconscout/react-unicons';

export default class AttendanceLogItem extends React.Component{
    render = () =>{
        return(
            <div className={`attendace-log-item ${this.props.AttendanceType.Value==="1001" ? "check-in" : "check-out" }`} >
                
                <Grid container >
                    <Grid item xs={3}>
                    <p className="attendace-log-item-time" align="center" variant="h4">{new jalaliMoment(this.props.LogDateTime,"YYYY-MM-DDTHH:mm:ss.SSS Z").format("HH:mm")}</p>
                    
                    </Grid>
                    <Grid item xs={7}>
                        <p className="m-0" > {this.props.AttendanceType.Name} </p>
                        <p className="m-0 font-weight-light h8">{this.props.Recorder.Workplace.Name}</p>
                    </Grid>
                    <Grid item xs={2} className="d-flex">
                            <Unicons.UilLocationPoint size={25} color="#000" className="m-auto"/>
                    </Grid>
                </Grid>
            </div>
            
        );
    }
}